import RequestPrice from './request-price';
export default RequestPrice;